<template>
    <div>
        
        <!-- Filter Start -->
        <div class="innerBox mb-4">
            <div class="row">
                <div class="col-md-2">
                    <a 
                        class="navbar-brand ml-3"
                        style="font: normal normal normal 16px/25px Poppins;">Cek Status SJ</a>
                </div>
                <div class="col-md-8" style="">
                    <input
                        class="form-control filterInput"
                        type="search"
                        placeholder="Masukkan Nomor SJ"
                        aria-label="Search"
                        style="display: flex; font: normal normal normal 16px/25px Poppins;"
                        v-model="filter.search"
                    >
                </div>
                <div 
                    class="col-md-2 text-right" 
                    style="display: flex; justify-content: flex-end">
                    <button
                        class="btn"
                        type="button"
                        style="
                            background-color: #1B698E; 
                            color: white; 
                            padding: 0 50px; 
                            height: 100%; 
                            font-weight: bold; 
                            display: flex; 
                            align-items: center; 
                            font: normal normal 600 14px/21px Poppins;"
                        @click="vue_universal_table.update++"
                    >CARI</button>
                </div>
            </div>
        </div>
        <!-- Filter End -->

        <!-- Table Start -->
        <div class="innerBox">

            <div class="mb-4 row">
                <div class="col-md-3">
                    <!-- <button class="btn btn--mpm--transporter" @click="requestFullScreen">Full Screen</button> -->
                </div>
                <div class="col-md-4 text-center" style="display: flex; flex-direction: column-reverse;">
                    <h3 class="mb-0" style="font: normal normal normal 16px/25px Poppins;">List Status SJ</h3>
                </div>
                <div class="col-md-1"></div>
                <div class="col-md-4">
                    <div class="d-flex">
                        <div class="col-4" style="display: flex; align-items: center; font: normal normal normal 12px/18px Poppins;">
                            <span style="font: normal normal normal 12px/18px Poppins;">Filter Tanggal</span>
                        </div>
                        <div class="col-8" style="font: normal normal normal 12px/18px Poppins;">
                            <flat-pickr
                                :config="rangePickr"
                                placeholder="Select Date"
                                v-model="selected.date"
                                style="font: normal normal normal 12px/18px Poppins;"
                            ></flat-pickr>
                        </div>
                    </div>
                </div>
            </div>

            <vue-universal-table
                api_url="/api/monitoring/status-sj"
                :filter="filter"
                :update="vue_universal_table.update"
                :fields="vue_universal_table.fields"
                :buttons="vue_universal_table.buttons"
                :process_data="vue_universal_table.process_data"
                :infinite_scroll="true"

                sort_order="ASC"
                sort_by="waktu_konfirmasi"
                style="font: normal normal normal 12px/18px Poppins;"
            ></vue-universal-table>
        </div>
        <!-- Table End -->
    </div>
</template>

<script>
    import moment from 'moment';
    import debounce from 'debounce';

    export default {
        metaInfo : {
            title : 'Monitoring Status SJ'
        },
        data () {
            let startDate = moment().startOf('year').format("YYYY-MM-DD");
            let currentDate = moment().format("YYYY-MM-DD");

            return {
                rangePickr: {
                    mode: 'range',
                    dateFormat: "Y-m-d",
                    altInput: true,
                    altFormat: "d-m-Y",
                    altInputClass: 'form-control input mpm--transporter--flatpickr'
                },
                selected : {
                    dateButtonsIndex : 2,
                    date : `${startDate} to ${currentDate}`
                },
                filter : {
                    search : '',
                    start: startDate,
                    end:currentDate
                },
                vue_universal_table : {
                    fields : [
                        {title:"NO SJ", variable:"no_sj", disable_sort: true},
                        {title:"NO TO", variable:"no_to", disable_sort: true},
                        {title:"TANGGAL SJ/TO", variable:"tanggal_sj", date_format:"DD MMM YYYY HH:mm:ss", disable_sort: true},
                        {title:"STATUS", variable:"status_sl"},
                        {title: "NO INVOICE", variable: "no_invoice", disable_sort: true },
                        {title:"WAKTU KONFIRMASI", variable:"waktu_konfirmasi"},
                        {title:"NOPOL", variable:"nopol"},
                        {title:"NAMA DRIVER", variable:"driver"},
                        {title:"EKSPEDISI", variable:"ekspedisi"}
                    ],
                    update : 0,
                },
            }
        },
        components : {

        },
        mounted () {

        },
        watch : {
            'selected.date' () {
                let split = this.selected.date.split(" to ");
                this.filter.start = split[0];
                this.filter.end = split.length > 1 ? split[1] : split[0];
                
                this.updateDebounceData();
            },
        },
        methods : {
            updateDebounceData: debounce(function () {
                this.vue_universal_table.update++
            }, 1500),
        }
    }
</script>

<style scoped>
    .innerBox {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;

    }

    .chart {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;
        align-items: center;
    }

    .elegant--sub-title {
        font-size: 18px;
        font-weight: 500;
        color: #9F9F9F;
    }

    .tableTitle {
        text-align: center;
    }

    /* .center {
        padding: 50px 20px;
        display: flexbox;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    } */

    .stats--icon {
        display:flex; 
        align-items:center; 
        justify-content:center;
        text-align: center;
    }

    .table td, .table th{
        text-align: center;
    }
</style>